// src/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      {/* Navbar */}
      <nav className="navbar">
          {/* Hamburger Icon */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <div className="logo">
        <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src="/img/pslogo.jpg" alt="Logo" />
          </Link>
        </div>

      
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
           <li> <Link 
  to="/#menu-section" 
  onClick={() => setMenuOpen(false)}
>
  Menu
</Link></li>
          <li> <Link to="/Blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>
          
          <li> <Link to="/Testimonial" onClick={() => setMenuOpen(false)}>Testimonials</Link></li>
          <li>
            <Link to="/collaboration" onClick={() => setMenuOpen(false)}>Collaboration</Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
          </li>
          <li style={{ display: 'none' }}>
          <button
  onClick={() => window.location.href = "https://onelink.to/xgb7ab"}
  className="download-btn"
>
  <img src="/img/downloadicon.png" alt="icon" className="btn-icon" />
  Download App
</button>

          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
